const roles = {
  SUPERUSER: {
    name: 'Superuser',
    hidden: true,
    roles: [
      'ADMIN'
    ],
    privileges: [
      'User.Create',
      'User.Read',
      'User.Update',
      'User.Delete',
      'Integration.Create',
      'Integration.Read',
      'Integration.Update',
      'Integration.Delete'
    ]
  },
  ADMIN: {
    name: 'Admin',
    description: 'Full access, including managing members and integrations.',
    roles: [
      'TECHNICAL',
      'CONTENT'
    ],
    privileges: [
      'AccountUser.Create',
      'AccountUser.Read',
      'AccountUser.Update',
      'AccountUser.Delete',
      'Integration.Read'
    ]
  },
  TECHNICAL: {
    name: 'Technical',
    description: 'Ability to make technical data changes.',
    privileges: [
      // Define any privileges the TECHNICAL role has access to
      'Page.Read',
      'Page.Update',
      'Integration.Read',
      'ImageOptimization.Read',
      'ImageOptimization.Update',
      'ImageOptimization.Delete'
    ],
    modules: []
  },
  CONTENT: {
    name: 'Content',
    description: 'Create, edit, and publish page content.',
    privileges: [
      'File.Create',
      'File.Delete',
      'Page.Create',
      'Page.Read',
      'Page.Update',
      'Page.Delete',
      'Page.Publish',
      'PageUser.Create',
      'PageUser.Read',
      'PageUser.Update',
      'PageUser.Delete',
      'Integration.Read'
    ],
    modules: [
      'CONTENT'
    ]
  },
  // Standalone feature flag (no inherited roles/privileges). Grants access to the
  // AI Generator. Only SUPERUSERs may assign it (superuserOnly), and it depends on
  // the CONTENT role (requiresRole) since the feature lives in the content editor.
  // Enforcement: members dialog (client) + account_user update route (server).
  AI_GENERATOR: {
    name: 'AI Generate Content',
    description: 'Generate and edit page content with AI. Requires Content.',
    superuserOnly: true,
    requiresRole: 'CONTENT',
    privileges: []
  }
}

module.exports = roles
